import React from 'react';
import { Skeleton } from '@mui/material';

export const SupportQueryCardSkeleton = () => (
    <div className="space-y-4">
        {[1, 2, 3].map((i) => (
            <div key={i} className="group bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-gray-200/50 p-6">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-3">
                        <Skeleton variant="rectangular" width={16} height={16} />
                        <Skeleton variant="rounded" width={80} height={24} />
                        <Skeleton variant="rounded" width={32} height={32} />
                        <Skeleton variant="rounded" width={70} height={24} />
                        <Skeleton variant="rounded" width={180} height={24} />
                    </div>
                </div>

                <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <div className="flex items-center mb-2">
                                <Skeleton variant="circular" width={16} height={16} className="mr-2" />
                                <Skeleton variant="text" width={120} height={20} />
                            </div>
                            <Skeleton variant="rounded" width="100%" height={40} />
                        </div>
                        <div>
                            <div className="flex items-center mb-2">
                                <Skeleton variant="circular" width={16} height={16} className="mr-2" />
                                <Skeleton variant="text" width={120} height={20} />
                            </div>
                            <Skeleton variant="rounded" width="100%" height={40} />
                        </div>
                    </div>

                    <div>
                        <div className="flex items-center mb-2">
                            <Skeleton variant="circular" width={16} height={16} className="mr-2" />
                            <Skeleton variant="text" width={120} height={20} />
                        </div>
                        <Skeleton variant="rounded" width="100%" height={40} />
                    </div>

                    <div>
                        <div className="flex items-center mb-2">
                            <Skeleton variant="circular" width={16} height={16} className="mr-2" />
                            <Skeleton variant="text" width={80} height={20} />
                        </div>
                        <Skeleton variant="rounded" width="100%" height={80} />
                    </div>

                    <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200/50">
                        <Skeleton variant="rounded" width={120} height={40} />
                        <Skeleton variant="rounded" width={120} height={40} />
                        <Skeleton variant="rounded" width={120} height={40} />
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-200/50 space-y-3">
                        <Skeleton variant="text" width={150} height={20} />
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <Skeleton variant="rounded" width="100%" height={24} />
                            <Skeleton variant="rounded" width="100%" height={24} />
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>
);

export const SupportQueryListSkeleton = () => (
    <div className="overflow-x-auto w-full">
        <table className="min-w-full bg-white rounded-xl shadow-md">
            <thead>
                <tr>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
                        <th key={i} className="px-4 py-3">
                            <Skeleton variant="text" width={i === 1 ? 20 : 80} height={20} />
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                    <tr key={i} className="border-t border-gray-100">
                        <td className="px-2 py-4">
                            <Skeleton variant="rectangular" width={16} height={16} className="mx-auto" />
                        </td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={60} height={20} /></td>
                        <td className="px-4 py-4"><Skeleton variant="rounded" width={70} height={24} /></td>
                        <td className="px-4 py-4">
                            <Skeleton variant="text" width={80} height={16} />
                            <Skeleton variant="text" width={60} height={16} />
                        </td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={100} height={20} /></td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={120} height={20} /></td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={100} height={20} /></td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={150} height={20} /></td>
                        <td className="px-4 py-4">
                            <div className="flex gap-1 flex-wrap">
                                <Skeleton variant="rounded" width={50} height={20} />
                                <Skeleton variant="rounded" width={50} height={20} />
                            </div>
                        </td>
                        <td className="px-4 py-4"><Skeleton variant="text" width={150} height={20} /></td>
                        <td className="px-4 py-4">
                            <div className="flex flex-col gap-2">
                                <Skeleton variant="rounded" width={100} height={32} />
                                <Skeleton variant="rounded" width={100} height={32} />
                                <Skeleton variant="rounded" width={100} height={32} />
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
